import { render, staticRenderFns } from "./HamburgerMenu.vue?vue&type=template&id=04975f56&scoped=true&"
import script from "./HamburgerMenu.vue?vue&type=script&lang=js&"
export * from "./HamburgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./HamburgerMenu.vue?vue&type=style&index=0&id=04975f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04975f56",
  null
  
)

export default component.exports